import { render, staticRenderFns } from "./xn--kyttluotto-q5a3t.vue?vue&type=template&id=55231513&"
import script from "./xn--kyttluotto-q5a3t.vue?vue&type=script&lang=js&"
export * from "./xn--kyttluotto-q5a3t.vue?vue&type=script&lang=js&"
import style0 from "./xn--kyttluotto-q5a3t.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports